import {makeAutoObservable, runInAction} from "mobx";
import {getPendingReviewRequestsCount} from "../http/reviewRequestsAPI";

export default class ReviewRequestsStatsStore {
  constructor() {
    this._pendingCount = 0;
    this._isLoading = false;
    makeAutoObservable(this, {}, {autoBind: true});
  }

  setPendingCount(count) {
    this._pendingCount = Number(count) || 0;
  }

  get pendingCount() {
    return this._pendingCount;
  }

  get isLoading() {
    return this._isLoading;
  }

  async loadPendingCount() {
    runInAction(() => {
      this._isLoading = true;
    });

    try {
      const data = await getPendingReviewRequestsCount();
      runInAction(() => {
        this.setPendingCount(data?.count);
      });
      return data;
    } finally {
      runInAction(() => {
        this._isLoading = false;
      });
    }
  }

  async handleSocketUpdated() {
    await this.loadPendingCount();
  }

  reset() {
    this._pendingCount = 0;
    this._isLoading = false;
  }
}
